import { serverURL } from '../config';

let mToken;
export function getToken() {
  if (mToken) {
    return mToken
  }
  mToken = localStorage.getItem('token')
  return mToken
}

export function setToken(token) {
  localStorage.setItem('token', token);
  mToken = token;
}

export async function post(path, data = {}) {
  return request(`${serverURL}${path}`, 'post', toForm(data));
}

export async function postJson(path, data = {}) {
  return request(`${serverURL}${path}`, 'post', JSON.stringify(data), true);
}

export async function put(path, data = {}) {
  return request(`${serverURL}${path}`, 'put', toForm(data));
}

export async function deleteRequest(path, data = {}) {
  return request(`${serverURL}${path}`, 'delete', toForm(data));
}

export async function get(path, data = {}) {
  const queryString = toForm(data);
  return request(`${serverURL}${path}?${queryString}`, 'get');
}

export function toForm(data) {
  const body = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value != null) {
      body.append(key, value)
    }
  })
  return new URLSearchParams(body).toString();
}

export async function request(url, method, body, json = false) {
  const token = getToken();
  const headers = {
    "Content-Type": json ? "application/json" : "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  }

  const response = await fetch(url, {
    method,
    body,
    headers,
  }).catch((err) => {
    return {
      success: false,
      message: err.message
    }
  });

  if (response.ok) {
    // 图片
    const info = response.headers.get('Content-Type')
    if (info && info.indexOf('image') !== -1) {
      return response;
    }
    if (response.body) {
      return response.json();
    }
  }

  if (response.status === 403) {
    return {
      success: false,
      message: "没有权限"
    }
  }

  return response.json();
}